module.exports = __webpack_public_path__ + "media/images/icons/cm-contact-form/text-f1d8d0b2a5927870c2b0011e60a0f090.svg";